import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Linkedin, Twitter, Instagram, ArrowRight } from 'lucide-react';
export const Contact = () => {
  return <main className="pt-24 bg-brand-warm-white min-h-screen" data-id="element-147" data-mp="1qpwbbjva144c">
      {/* Hero */}
      <section className="bg-brand-navy py-24 text-white relative overflow-hidden" data-id="element-148" data-mp="1lqjhgf5zmws9">
        <div className="absolute inset-0 opacity-10" data-id="element-149" data-mp="1lofbzssfxppv">
          <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/patterns/generated-images/71a47677-f75f-4223-9322-a9cb08464282.jpg')] bg-cover bg-center" data-id="element-150" data-mp="y1h3bhakbm2i" />
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-151" data-mp="17rk3q2k0k2av">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-6 block" data-id="element-152" data-mp="aabmozwsspr5">
            Contact Us
          </span>
          <h1 className="text-4xl md:text-7xl font-display mb-8" data-id="element-153" data-mp="15dm7391qj3bu">
            Begin Your <br data-id="element-154" data-mp="19f7foi78kvg8" />
            <span className="italic text-brand-gold" data-id="element-155" data-mp="19exquxxxguc4">Consultation</span>.
          </h1>
          <p className="text-xl text-white/70 max-w-2xl leading-relaxed" data-id="element-156" data-mp="1e8imwkfyne8o">
            Our partners are ready to discuss your strategic goals and financial
            complexities. Connect with us to explore how we can drive your
            growth.
          </p>
        </motion.div>
      </section>

      <section className="py-16 md:py-24" data-id="element-157" data-mp="qifx6aziqkd8">
        <div className="max-w-7xl mx-auto px-6" data-id="element-158" data-mp="vgpxf003ob5p">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-159" data-mp="vfy11myoi9ed">
            {/* Contact Info */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="space-y-16" data-id="element-160" data-mp="10hnef99diz5m">
              <div data-id="element-161" data-mp="1had8rbt46st0">
                <h2 className="text-3xl font-display text-brand-navy mb-12" data-id="element-162" data-mp="1w59la17yi2bw">
                  Direct Channels
                </h2>
                <div className="space-y-8 md:space-y-10" data-id="element-163" data-mp="1r7hu59f4yk8r">
                  <div className="flex gap-5 md:gap-8" data-id="element-164" data-mp="13gvmhj91n1za">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-brand-navy flex items-center justify-center text-brand-gold shrink-0" data-id="element-165" data-mp="13hdqx35v0mia">
                      <Phone size={20} className="md:w-6 md:h-6" data-id="element-166" data-mp="1d6f64r4kyzv7" />
                    </div>
                    <div data-id="element-167" data-mp="18fyu9bgermay">
                      <div className="text-[10px] md:text-xs uppercase tracking-widest text-brand-charcoal/40 mb-1 md:mb-2 font-bold" data-id="element-168" data-mp="18fp0dcs8suzz">
                        Call Our Partners
                      </div>
                      <div className="text-base md:text-2xl font-medium text-brand-navy" data-id="element-169" data-mp="fs2vm17a3kbj">
                        240-882-3949
                      </div>
                      <div className="text-xs md:text-sm text-brand-charcoal/40 mt-1" data-id="element-170" data-mp="2rcto4cjtwyf7">
                        Mon - Fri, 9am - 6pm EST
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-5 md:gap-8" data-id="element-171" data-mp="2mfjtmihl1wki">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-brand-navy flex items-center justify-center text-brand-gold shrink-0" data-id="element-172" data-mp="2mg38trfum6uu">
                      <Mail size={20} className="md:w-6 md:h-6" data-id="element-173" data-mp="3f3z3kqluxooz" />
                    </div>
                    <div className="min-w-0 flex-1" data-id="element-174" data-mp="314g930lyybv5">
                      <div className="text-[10px] md:text-xs uppercase tracking-widest text-brand-charcoal/40 mb-1 md:mb-2 font-bold" data-id="element-175" data-mp="313wplfgo7ff0">
                        Email Our Advisory
                      </div>
                      <div className="text-base md:text-2xl font-medium text-brand-navy break-all" data-id="element-176" data-mp="1pnq1bd1wdbzf">
                        Emmanuel@consiliumadvisory.com
                      </div>
                      <div className="text-xs md:text-sm text-brand-charcoal/40 mt-1" data-id="element-177" data-mp="29ystjmvn5lil">
                        We respond within 24 hours
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-5 md:gap-8" data-id="element-178" data-mp="208r6myf0y959">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-brand-navy flex items-center justify-center text-brand-gold shrink-0" data-id="element-179" data-mp="1v9mt5vl2hp94">
                      <MapPin size={20} className="md:w-6 md:h-6" data-id="element-180" data-mp="2sw3oiva8pss8" />
                    </div>
                    <div data-id="element-181" data-mp="2nylf73sb9bjp">
                      <div className="text-[10px] md:text-xs uppercase tracking-widest text-brand-charcoal/40 mb-1 md:mb-2 font-bold" data-id="element-182" data-mp="2nvz5axhy6jyb">
                        Visit Our Office
                      </div>
                      <div className="text-base md:text-2xl font-medium text-brand-navy" data-id="element-183" data-mp="17jk4zqk9x3fs">
                        13635 Old Annapolis Road, <br data-id="element-184" data-mp="13hff92wy4qyf" />
                        Bowie, MD 20706
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div data-id="element-185" data-mp="3j6vt496j418r">
                <h2 className="text-3xl font-display text-brand-navy mb-8" data-id="element-186" data-mp="3j645pln359tk">
                  Global Presence
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-187" data-mp="3o4fgbyl7focu">
                  <div className="p-6 md:p-8 rounded-3xl bg-white border border-brand-navy/5 shadow-sm" data-id="element-188" data-mp="3swyqelkoo1cw">
                    <h4 className="font-heading font-bold text-brand-navy mb-2" data-id="element-189" data-mp="1pcjmk2o3irt">
                      United States
                    </h4>
                    <p className="text-sm text-brand-charcoal/60 leading-relaxed" data-id="element-190" data-mp="6rle5kv6usw1">
                      Maryland HQ & Strategic Hub
                    </p>
                  </div>
                  <div className="p-6 md:p-8 rounded-3xl bg-white border border-brand-navy/5 shadow-sm" data-id="element-191" data-mp="fpncfsnjf7fm">
                    <h4 className="font-heading font-bold text-brand-navy mb-2" data-id="element-192" data-mp="2ck9xdjakxzkz">
                      Nigeria
                    </h4>
                    <p className="text-sm text-brand-charcoal/60 leading-relaxed" data-id="element-193" data-mp="3ks64c5fpggh1">
                      Lagos Regional Advisory
                    </p>
                  </div>
                </div>
              </div>

              <div data-id="element-194" data-mp="3ttnjnllage4o">
                <h2 className="text-3xl font-display text-brand-navy mb-8" data-id="element-195" data-mp="3ttx8v6yieh9b">
                  Follow Our Insights
                </h2>
                <div className="flex gap-4" data-id="element-196" data-mp="3ow5iwihfd57r">
                  <a href="#" className="w-12 h-12 rounded-full bg-white border border-brand-navy/5 flex items-center justify-center text-brand-navy hover:bg-brand-gold hover:text-white transition-all" data-id="element-197" data-mp="7l4bomsnt5j4">
                    <Linkedin size={20} data-id="element-198" data-mp="gg2ceg21tml0" />
                  </a>
                  <a href="#" className="w-12 h-12 rounded-full bg-white border border-brand-navy/5 flex items-center justify-center text-brand-navy hover:bg-brand-gold hover:text-white transition-all" data-id="element-199" data-mp="cd5yh2ngeene">
                    <Twitter size={20} data-id="element-200" data-mp="14ykuoj0m4phm" />
                  </a>
                  <a href="#" className="w-12 h-12 rounded-full bg-white border border-brand-navy/5 flex items-center justify-center text-brand-navy hover:bg-brand-gold hover:text-white transition-all" data-id="element-201" data-mp="14x1estivcggd">
                    <Instagram size={20} data-id="element-202" data-mp="zyq127pgdlsv" />
                  </a>
                </div>
              </div>
            </motion.div>

            {/* Form */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="bg-white p-8 lg:p-16 rounded-3xl lg:rounded-[40px] shadow-2xl border border-brand-navy/5" data-id="element-203" data-mp="qzct5jgz95a9">
              <h2 className="text-3xl font-display text-brand-navy mb-8" data-id="element-204" data-mp="7d6q7r8rioef">
                Send an Inquiry
              </h2>
              <form className="space-y-8" data-id="element-205" data-mp="ir8n1ah0rzkn">
                <div className="grid md:grid-cols-2 gap-8" data-id="element-206" data-mp="isjoh3mzsv8l">
                  <div className="space-y-3" data-id="element-207" data-mp="drw06pq5esi2">
                    <label className="text-xs uppercase tracking-widest font-bold text-brand-navy" data-id="element-208" data-mp="durxqcy33f5z">
                      Full Name
                    </label>
                    <input type="text" className="w-full bg-brand-warm-white border-none p-5 rounded-2xl focus:ring-2 focus:ring-brand-gold outline-none transition-all" placeholder="John Doe" data-id="element-209" data-mp="4t26p8846i8q" />
                  </div>
                  <div className="space-y-3" data-id="element-210" data-mp="3m9jp5jeke3mb">
                    <label className="text-xs uppercase tracking-widest font-bold text-brand-navy" data-id="element-211" data-mp="3m6nqttyt1cxc">
                      Email Address
                    </label>
                    <input type="email" className="w-full bg-brand-warm-white border-none p-5 rounded-2xl focus:ring-2 focus:ring-brand-gold outline-none transition-all" placeholder="john@company.com" data-id="element-212" data-mp="3d93sassbtuqf" />
                  </div>
                </div>
                <div className="space-y-3" data-id="element-213" data-mp="21on1y15e0g75">
                  <label className="text-xs uppercase tracking-widest font-bold text-brand-navy" data-id="element-214" data-mp="26pssbsbkrrdi">
                    Subject
                  </label>
                  <select className="w-full bg-brand-warm-white border-none p-5 rounded-2xl focus:ring-2 focus:ring-brand-gold outline-none transition-all appearance-none" data-id="element-215" data-mp="18zxw5otdzmp2">
                    <option data-id="element-216" data-mp="1iydr62vjbg3u">Tax & Accounting</option>
                    <option data-id="element-217" data-mp="1nr6tkk3j6ccr">Strategic Advisory</option>
                    <option data-id="element-218" data-mp="1nrzsiyw8zxkc">Capital Solutions</option>
                    <option data-id="element-219" data-mp="qc2peow6z95g">Other Inquiry</option>
                  </select>
                </div>
                <div className="space-y-3" data-id="element-220" data-mp="v9uj9oged5ca">
                  <label className="text-xs uppercase tracking-widest font-bold text-brand-navy" data-id="element-221" data-mp="v8jf3nj1hvkn">
                    Message
                  </label>
                  <textarea rows={6} className="w-full bg-brand-warm-white border-none p-5 rounded-2xl focus:ring-2 focus:ring-brand-gold outline-none transition-all" placeholder="How can we help you?" data-id="element-222" data-mp="tw5mtc1nlal1" />
                </div>
                <button className="w-full bg-brand-navy text-white py-6 rounded-2xl text-sm font-bold tracking-widest uppercase hover:bg-brand-gold transition-all flex items-center justify-center gap-4" data-id="element-223" data-mp="67vxi058e4p5">
                  Submit Inquiry <ArrowRight size={18} data-id="element-224" data-mp="g4igskhwsnp2" />
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Interactive Map */}
      <section className="h-[500px] bg-brand-navy/5 relative overflow-hidden" data-id="element-225" data-mp="3jmsh3tvzfcbj">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="absolute inset-0" data-id="element-226" data-mp="3oktzsdphx9mh">
          <iframe title="Consilium Advisory Office Location" src="https://maps.google.com/maps?q=13635%20Old%20Annapolis%20Road%20Bowie,%20MD%2020706&t=&z=13&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-227" data-mp="1wohyz90sihl3" />
        </motion.div>
      </section>
    </main>;
};